import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Device } from '../../../models/device';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DevicesService } from '../../../services/devices.service';
import { LoginUserModel } from '../../../models/loginUserModel';
import { getObjectDiff } from '../fuel-params-form/fuel-params-form.component';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';

import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-card-data-form',
  imports: [
    FormsModule, ReactiveFormsModule, CommonModule,
    InputTextModule, ToggleSwitchModule, SelectButtonModule, SelectModule,
    ButtonModule, ChipModule, TooltipModule, DialogModule
  ],
  templateUrl: './card-data-form.component.html',
  styleUrl: './card-data-form.component.scss'
})
export class CardDataFormComponent {
  formCard!: FormGroup;
  allProducts = [
    { value: 1, product: 'Regular' },
    { value: 2, product: 'Supreme' },
    { value: 3, product: 'Diesel' }
  ];
  cardProducts: any[] = [];
  showMessageError = false;
  messagesError = '';
  statusValue = false;
  showAddProduct = false;

  @HostListener('document:click', ['$event'])
  onDocClick(e: Event) {
    if (this.showAddProduct && !(e.target as HTMLElement).closest('.relative')) this.showAddProduct = false;
  }

  @Input() device!: any;
  @Output() onSaving = new EventEmitter<any>();
  @Output() onResponse = new EventEmitter<any>();
  data!: LoginUserModel;
  oldDevice!: Device;
  showConfirm = false;
  messageConfirm = '';
  changes: any = null;
  videoOptions = [{ label: 'Si', value: 1 }, { label: 'No', value: 0 }];

  get isAdmin() { return this.data.UserType === 'Administrator' || this.data.UserType === 'Modify'; }

  constructor(private router: Router, private fb: FormBuilder, private service: DevicesService) {
    this.data = JSON.parse(localStorage.getItem('data')!);
  }

  ngOnInit() {
    if (!this.device) { this.router.navigate(['app/dispositivos']); return; }
    this.oldDevice = structuredClone(this.device);
    this.cardProducts = this.getProducts(this.device);
    if (this.device.cardStatus === 'C') { this.router.navigate(['app/dispositivos']); return; }

    let deviceType = '';
    if (this.device.isMaster === 1 || this.device.deviceType === 'M' || this.device.description?.toUpperCase().includes('MAESTRA')) deviceType = 'MAESTRA';
    else if (this.device.deviceType === 'TG') deviceType = 'TIBORES Y GALONES';
    else if (this.device.isMaster === 0 && this.device.deviceType === 'UP') deviceType = 'UNIDAD CON PLACAS';

    this.statusValue = this.device.cardStatus?.trim() === 'A';
    this.formCard = this.fb.group({
      cardNumber: new FormControl({ value: this.device.number?.toString().padStart(5, '0') || '', disabled: true }),
      status: new FormControl(this.statusValue),
      deviceType: new FormControl({ value: deviceType, disabled: true }),
      enableVideoLoad: new FormControl(this.device.videoLoad == 1 ? 1 : 0)
    });
  }

  get availableProducts() {
    return this.allProducts.filter(p => !this.tieneProducto(p.value));
  }

  removeProduct(product: any) {
    if (!this.isAdmin || this.cardProducts.length <= 1) return;
    this.cardProducts = this.cardProducts.filter(p => p.value !== product.value);
  }

  tieneProducto(v: number) { return this.cardProducts.some(p => p.value === v); }

  addProduct(product: any) {
    if (!this.isAdmin) return;
    const isMaster = this.device.isMaster === 1 || this.device.description?.toUpperCase().includes('MAESTRA') || this.device.deviceType === 'TG' || this.device.deviceType === 'M';
    if (isMaster) {
      const idx = this.cardProducts.findIndex(p => p.value === product.value);
      if (idx > -1 && this.cardProducts.length > 1) this.cardProducts.splice(idx, 1);
      else if (idx === -1) this.cardProducts.push(this.allProducts.find(e => e.value === product.value)!);
    } else {
      if (this.tieneProducto(3) && product.value !== 3) { this.cardProducts = [this.allProducts.find(e => e.value === product.value)!]; }
      else if (!this.tieneProducto(3) && product.value === 3) { this.cardProducts = [this.allProducts.find(e => e.value === 3)!]; }
      else {
        const idx = this.cardProducts.findIndex(p => p.value === product.value);
        if (idx > -1 && this.cardProducts.length > 1) this.cardProducts.splice(idx, 1);
        else if (idx === -1) this.cardProducts.push(this.allProducts.find(e => e.value === product.value)!);
      }
    }
  }

  onStatusChange(val: boolean) { this.formCard.get('status')?.setValue(val); this.statusValue = val; }

  showConfirmDialog() {
    this.device.product = this.getSelectedProducts();
    this.device.cardStatus = this.formCard.get('status')!.value ? 'A' : 'I';
    this.changes = getObjectDiff(this.oldDevice, this.device, ['product', 'cardStatus']);
    this.changes = this.changes.replace('product', 'Producto(s)').replace('cardStatus', 'Estatus')
      .replace('A', 'Activo').replace('I', 'Inactivo').replace('123', 'Todos')
      .replace('12', 'Regular - Supreme').replace('1', 'Regular').replace('2', 'Supreme').replace('3', 'Diesel');
    if (this.changes) { this.messageConfirm = this.changes; this.showConfirm = true; }
  }

  saveCardData() {
    if (!this.formCard.valid) return;
    this.onSaving.emit(true);
    this.service.saveCardParams(this.device, this.data.Client_number, this.data.User_id, 'Tarjeta', this.data.UserType === 'Administrator' ? 'Administrador de la cuenta' : this.data.Name).subscribe({
      next: (resp: any) => {
        this.onSaving.emit(false);
        if (resp.errorCode === 1) { this.showMessageError = true; this.messagesError = resp.errorDesc; }
        else { resp.isSave = true; this.onResponse.emit(resp); this.oldDevice = structuredClone(this.device); }
      },
      error: (err: any) => { this.onSaving.emit(false); this.showMessageError = true; this.messagesError = err.error?.error || 'Error al guardar'; }
    });
  }

  getSelectedProducts() {
    let p = '';
    if (this.tieneProducto(1)) p += '1';
    if (this.tieneProducto(2)) p += '2';
    if (this.tieneProducto(3)) p += '3';
    return p;
  }

  getProducts(device: any) {
    const map: any = {
      '1': [{ value: 1, product: 'Regular' }], '2': [{ value: 2, product: 'Supreme' }],
      '3': [{ value: 3, product: 'Diesel' }],
      '12': [{ value: 1, product: 'Regular' }, { value: 2, product: 'Supreme' }],
      '13': [{ value: 1, product: 'Regular' }, { value: 3, product: 'Diesel' }],
      '23': [{ value: 2, product: 'Supreme' }, { value: 3, product: 'Diesel' }],
      '123': [{ value: 1, product: 'Regular' }, { value: 2, product: 'Supreme' }, { value: 3, product: 'Diesel' }]
    };
    return map[device.product?.trim()] || [];
  }
}
